import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DeliverablesListStoreEffects } from './deliverables-list.effects';
import { deliverablesListReducer } from './deliverables-list.reducer';
import { fhDeliverableIdsReducer } from './deliverables-listfh.reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('deliverablesList', deliverablesListReducer),
    StoreModule.forFeature('fhDeliverableIds', fhDeliverableIdsReducer),
    EffectsModule.forFeature([DeliverablesListStoreEffects]),
  ],
})
export class DeliverablesListStateModule {}
